import React, { Component } from 'react'
import { Link } from 'react-router-dom'
import { Form, Icon, Input, Button, Spin, Alert, message } from 'antd'
import './login.css'
import loginLogo from './logo.png'
import ReCAPTCHA from 'react-google-recaptcha'
import { reCAPTCHA_site_key } from "../../utils/Constants";
import axios from 'axios'

const FormItem = Form.Item
const antIcon = <Icon type="loading" style={{ fontSize: 24 }} spin />

class Login extends Component {
  state = {
    visible_pass: false,
    success: false,
    loading: false,
    errorMessage: '',
    captchaValue: null,
    googleRecaptchaEnable: null,
  }
  componentDidMount = () => {
    axios.get("/api/get_captcha").then((res) => {
      if (res.data && res.data.success) {
        this.setState({ googleRecaptchaEnable: res.data.REACT_APP_GOOGLE_RECAPTCHA_ENABLE })
      }
    })
    window.document.body.classList.add('login')
  }
  componentWillUnmount = () => {
    window.document.body.classList.remove('login')
  }
  login = (e) => {
    const { history } = this.props;
    const { captchaValue, googleRecaptchaEnable } = this.state

    e.preventDefault()
    this.setState({
      success: false,
      loading: false,
      errorMessage: '',
    })
    if (googleRecaptchaEnable === true) {
      if (!captchaValue) {
        message.error('Please verify the reCAPTCHA!')
        return false;
      }
    }

    this.props.form.validateFields((err, values) => {
      if (!err) {
        this.setState({ loading: true })
        if (googleRecaptchaEnable === true) {
          values.captchaValue = captchaValue;
        }

        this.props.login(values, (result) => {
          if (result.success) {
            if (result.user.user_type === 'SUPER_ADMIN')
              history.push('/super-admin')
            else if (result.user.user_type === 'EA' && result.user.id === 2) {
              // history.push('/bfiles')
              history.push('/dashboard')
            } else {
              history.push('/dashboard')
            }
          } else {
            this.setState({
              loading: false,
              errorMessage: result.errorMessage,
            })
          }
        })
      }
    })
  }

  toggleVisibility = () => {
    this.setState(prevState => ({
      visible_pass: !prevState.visible_pass
    }));
  };

  render() {
    const { success, visible_pass, loading, errorMessage, googleRecaptchaEnable } = this.state
    const { getFieldDecorator } = this.props.form

    return (
      <div style={{ 
        display: 'flex', 
        justifyContent: 'center', 
        alignItems: 'center', 
        minHeight: '100vh' // Full viewport height
      }}>
        <Form onSubmit={this.login} className="login-form">
          <div className="login-form-header">
            <img src={loginLogo} alt="B File" />
          </div>
          {errorMessage !== '' ? (
            <FormItem>
              <Alert message={errorMessage} type="error" />
            </FormItem>
          ) : null}
          <FormItem>
            {getFieldDecorator('email', {
              rules: [
                {
                  type: 'email',
                  message: 'Email is invalid.',
                },
                {
                  required: true,
                  message: 'Email field is required.',
                },
              ],
            })(
              <Input
                prefix={<Icon type="user" style={{ color: 'rgba(0,0,0,.25)' }} />}
                placeholder="Email"
              />,
            )}
          </FormItem>
          <FormItem>
            {getFieldDecorator('password', {
              rules: [{ required: true, message: 'Password field is required.' }],
            })(
              <Input
                prefix={<Icon type="lock" style={{ color: 'rgba(0,0,0,.25)' }} />}
                type={visible_pass ? 'text' : 'password'}
                placeholder="Password"
                suffix={
                  <Icon
                    type={visible_pass ? 'eye-invisible' : 'eye'}
                    onClick={this.toggleVisibility}
                    style={{ cursor: 'pointer' }}
                  />
                }
              />,
            )}
          </FormItem>
          {googleRecaptchaEnable === true ? <ReCAPTCHA sitekey={reCAPTCHA_site_key} onChange={(e) => this.setState({ captchaValue: e })} /> : null}
          <FormItem>
            {loading ? (
              <Spin indicator={antIcon} />
            ) : (
              <div>
                <Button
                  type="primary"
                  htmlType="submit"
                  className="login-form-button"
                >
                  Log in
                </Button>
                <Link to="/forgot-password" className="login-form-forgot">
                  Forgot password
                </Link>
                or <Link to="/register">Register now!</Link>
              </div>
            )}
          </FormItem>
          <div className="acknowledge">
            By selecting to login you are acknowledging the{' '}
            <a
              href="/app/#/terms-of-service/"
              target="_blank"
              rel="noopener noreferrer"
            >
              terms and conditions
            </a>{' '}
            of the licensing agreement issued by PersistEplan Software LLC
          </div>
        </Form>
      </div>
    )
  }
}

const WrappedNormalLoginForm = Form.create()(Login)
export default WrappedNormalLoginForm



// WEBPACK FOOTER //
// ./src/scenes/Login/index.js